<template>
  <section class="module">
    <div class="container">
      <div class="item" v-for="(item, i) in list" :key="i">
        <div class="tt">{{ item.name }}</div>
        <div class="intro">{{ item.intro }}</div>
        <div class="btn">More About Scholarship ></div>
        <img :src="item.img" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
.module {
  padding: 24px 0;
  margin-top: 80px;

  .container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 auto;
    width: 1500px;
  }

  .item {
    margin-right: 60px;
    margin-bottom: 48px;
    width: 570px;

    &:nth-child(2n),
    &:last-child {
      margin-right: 0;
    }

    &:last-child {
      margin-left: 315px;
    }

    .tt {
      margin-bottom: 20px;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
    }

    .intro {
      font-size: 14px;
      margin-bottom: 16px;
      color: #666;
    }

    .btn {
      margin-bottom: 48px;
      font-size: 16px;
      color: #409eff;
    }

    img {
      width: 100%;
    }
  }
}
</style>
